import { assetUrl } from "@/constants/assetUrl"
import { GuardianIconName } from "@/constants/guardianIconNames"

const ICONS: Record<GuardianIconName, string> = {
  arena: assetUrl("lor/arena.png"),
  cards: assetUrl("lor/cards.png"),
  card: assetUrl("lor/card.png"),
  chakra: assetUrl("lor/chakra.png"),
  energy: assetUrl("lor/energy.png"),
  fight: assetUrl("lor/fight.png"),
  first: assetUrl("lor/first.png"),
  history: assetUrl("lor/history.png"),
  kubok: assetUrl("lor/kubok.png"),
  monet: assetUrl("lor/monet.png"),
  rang: assetUrl("lor/rang.png"),
  second: assetUrl("lor/second.png"),
  third: assetUrl("lor/third.png"),
  map: assetUrl("lor/map.png"),
  question: assetUrl("lor/question.png"),
  rules: assetUrl("lor/rules.png"),
  global: assetUrl("lor/global.png"),
  daily: assetUrl("lor/daily.png"),
  quests: assetUrl("lor/quests.png"),
  shop: assetUrl("lor/shop.png"),
  friends: assetUrl("lor/friends.png"),
  oneonone: assetUrl("lor/1on1.png"),
  radar: assetUrl("lor/radar.png"),
  rating: assetUrl("lor/rating.png"),
  room: assetUrl("lor/room.png"),
  trainer: assetUrl("lor/trainer.png"),
  flag: assetUrl("lor/flag.png"),
  chronicle: assetUrl("lor/chronic.png"),
  notice: assetUrl("lor/profile/notice.png"),
  almanac: assetUrl("lor/profile/almanah.png"),
  wardrobe: assetUrl("lor/garderob.png"),
  shard: assetUrl("lor/shard.png"),
  fuse: assetUrl("lor/sliv.png"),
  styleChange: assetUrl("lor/reverse.png"),
  paycard: assetUrl("lor/paycard.png"),
  academy: assetUrl("lor/academy.png"),
  airship: assetUrl("lor/profile/dirizhabl.png"),
}

interface GuardianIconProps {
  name: GuardianIconName
  size: number
  className?: string
}

export default function GuardianIcon({
  name,
  size,
  className,
}: GuardianIconProps) {
  return (
    <img
      src={ICONS[name]}
      alt=""
      width={size}
      height={size}
      className={className}
      style={{ width: size, height: size }}
      draggable={false}
    />
  )
}
